import * as React from 'react';
import { applyConfig, ConfigContext } from './context';
export const withConfig = (Component, config) => {
    return () => (React.createElement(ConfigContext.Provider, { value: applyConfig(config) },
        React.createElement(Component, null)));
};
